import React from 'react';

import Plot from 'react-plotly.js';
import strftime from 'strftime';

import { Evento } from '../api/types';
import LoadingCircle from '../components/LoadingCircle'
import { rgb_string_from_name } from '../utils'
import { usePunteggi } from '../reducers';

interface IProps {
  pk: number,
  nomi: { [squadra: string]: string; },
  evento: Evento,
  currentTs: Date,
  replayMode: boolean,
}


type ClassificaTempo = ReturnType<typeof usePunteggi>["classifica_tempo"]

const get_replay_classifica = (replayMode: boolean, currentTs: Date, classifica_tempo: ClassificaTempo) => {
  if (!replayMode) return classifica_tempo;

  // Sono ordinati decrescenti
  const last_idx = classifica_tempo.tempi.findIndex(time => time.getTime() < currentTs.getTime());


  // Quindi si prende lo slice da last_idx al fondo.
  const newpunteggi = Object.fromEntries(
    Object.entries(classifica_tempo.punteggi).map(([name, pti_arr]) => [name, pti_arr.slice(last_idx)])
  );

  return {
    tempi: classifica_tempo.tempi.slice(last_idx),
    punteggi: newpunteggi,
  }
}

const GraficoPunteggi = (props: IProps) => {

  const { evento, nomi, pk, currentTs, replayMode } = props;
  const punteggi = usePunteggi(pk);

  if (evento) {
    const adesso = new Date();
    const inizio = new Date(evento.inizio);
    if (inizio > adesso) {
      return <p>{"L'evento non è ancora iniziato."}</p>;
    }
  }

  const pp = punteggi?.classifica_tempo;
  if (!pp) return <LoadingCircle />;
  const p = get_replay_classifica(replayMode, currentTs, pp);

  let plot_data = [];
  const time_format = "%Y-%m-%d %H:%M:%S";
  for (let squadra in p.punteggi) {
    if (p.punteggi.hasOwnProperty(squadra)) {
      let tempi_filtrati = [];
      let punteggi_filtrati = []
      let nome = nomi[squadra];
      const pti = p.punteggi[squadra];
      tempi_filtrati.push(strftime(time_format, p.tempi[0]));
      punteggi_filtrati.push(pti[0]);
      for (let i = 1; i < pti.length - 1; i++) {
        if (pti[i] == pti[i - 1]) {
          continue;
        }
        tempi_filtrati.push(strftime(time_format, p.tempi[i]));
        punteggi_filtrati.push(pti[i]);
      }
      tempi_filtrati.push(strftime(time_format, p.tempi[p.tempi.length - 1]));
      punteggi_filtrati.push(pti[pti.length - 1]);
      const color = rgb_string_from_name(squadra);
      plot_data.push({
        x: tempi_filtrati,
        y: punteggi_filtrati,
        type: "scatter" as "scatter", // Nessun commento su questo casting esplicito.
        mode: 'lines+markers' as "lines+markers", // Mannaggia a typescript.
        name: nome,
        marker: {
          color: color,
          size: 8,
        },
        line: {
          color: color,
          width: 2,
        },
      });
    }
  }
  const horiz = (window.innerWidth > window.innerHeight);
  const legend = horiz ? {} : {
    orientation: "h" as "h",
    y: -0.2, // push it below the chart
    x: 0,
    xanchor: 'left',
  };
  return (
    <Plot
      data={plot_data}
      layout={{
        autosize: true,
        title: "Punteggio",
        showlegend: true,
        // @ts-ignore
        legend: legend
      }}
      useResizeHandler={true}
      config={{ responsive: true }}
      style={{ width: '100%', height: '100%', minHeight: "600px", }}

    />
  );
}


export default GraficoPunteggi;
